'use strict';

var Steps = require('./Steps');
Steps.Step = require('./Step');

module.exports = Steps;


/*****************
 ** WEBPACK FOOTER
 ** ./~/rc-steps/lib/index.js
 ** module id = 631
 ** module chunks = 0
 **/